// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","info":"Footer_info__2OKti","info-and-address":"Footer_info-and-address__BXUaY","social":"Footer_social__2oU8C","logo":"Footer_logo__GkEml"};